import { Link } from 'react-router';
import { ROUTE_META } from '~/data/route-metadata';

interface BreadcrumbsProps {
  path: string;        // Current route path
  pageLabel: string;   // Display label for current page
}

/**
 * Helper: Generate JSON-LD-ready breadcrumb items for use in route meta.
 * Returns array of {name, url} for passing to breadcrumbSchema() in seo.ts.
 */
export function breadcrumbSchemaItems(path: string): Array<{ name: string; url: string }> {
  const items: Array<{ name: string; url: string }> = [
    { name: 'Home', url: 'https://nlcstpete.com/' },
  ];

  const meta = ROUTE_META[path];
  if (!meta?.parents) return items;

  // Add parent breadcrumbs
  for (const parent of meta.parents) {
    items.push({
      name: parent.label,
      url: `https://nlcstpete.com${parent.path}`,
    });
  }

  // Add current page (no URL for current)
  items.push({
    name: meta.label,
    url: `https://nlcstpete.com${path}`,
  });

  return items;
}

/**
 * Breadcrumb navigation component.
 * Renders <nav aria-label="breadcrumb"> with parent trail and current page.
 */
export function Breadcrumbs({ path, pageLabel }: BreadcrumbsProps) {
  const meta = ROUTE_META[path];

  // No breadcrumbs on pages without parent hierarchy
  if (!meta?.parents || meta.parents.length === 0) {
    return null;
  }

  const parents = meta.parents;

  return (
    <nav aria-label="breadcrumb" className="breadcrumbs">
      <ol>
        <li>
          <Link to="/">Home</Link>
        </li>
        {parents.map((parent) => (
          <li key={parent.path}>
            <Link to={parent.path}>{parent.label}</Link>
          </li>
        ))}
        <li aria-current="page">{pageLabel}</li>
      </ol>
    </nav>
  );
}
